
 import React from "react";
 import { Button, Col, FormGroup, FormProps, Input, InputGroup, InputGroupText, Label, ListGroup, ListGroupItem, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

import { CommonUtils,  } from "./common/CommonUtils";
import {  TextBox } from "./common/Components/TextBox";
import {  LoadingSpinner, FieldLabel } from "./common/Components/CommonComponents";
import {  Status } from "./common/Components/CommonModels";

import { StudentCertificate } from "../MagInstituteModels";
import { StudentCourseService } from "../StudentCourseService";
import { NutFill } from "react-bootstrap-icons";
import { NavBar } from "./NavBar";
import { Container, Nav, Navbar } from "react-bootstrap";

import logo from '../assets/img/LOGO.png';

 class PropsModel {

 }

 class InputForm {

     certificateNumber: string;
 }


 class StateModel {

     status: Status;

     statusMessage: string;

     certificate: StudentCertificate;

     //This is for the first time. 
     //By default, certificate will be NULL and so it will show "Ivalid certificae"
//     //So we maintain the certificate validity seperately.
      isValidCertificate: boolean;
 }


 export class ValidateCertificate extends React.Component<PropsModel, StateModel>
 {
     studentCourseService: StudentCourseService;

     formState: InputForm;
     //stateModel: StateModel;

     constructor(props: any) {
         super(props);

         this.state = {
             status: Status.None,
             statusMessage: "",
             certificate: null,
             isValidCertificate: null
         };

         this.studentCourseService = new StudentCourseService();
         this.formState = new InputForm();
     }


    componentDidMount(): void {
      
            document.title = "Mag Institure of Maritime Academy";
     
    }

     renderCertificateDetails() {

        var certificate = this.state.certificate;
        return (
        <div>
            <Row className="subHeader">
                Certification Details
            </Row>

            <br />

            <Row className="pdTop10">

                <Col xs="3">
                    <FieldLabel label="Certificate #">
                        <span>{certificate.certificateNumber}</span>
                    </FieldLabel>
                </Col>

                <Col xs="3">
                    <FieldLabel label="Student Name">
                        <span>{certificate.firstName} {certificate.lastName}</span>
                    </FieldLabel>
                </Col>

                <Col xs="3">
                    <FieldLabel label="Indos #">
                        <span>{certificate.inDosNumber} </span>
                    </FieldLabel>
                </Col>

                <Col xs="3">
                    <FieldLabel label="Passport #">
                        <span>{certificate.passportNumber} </span>
                    </FieldLabel>
                </Col>
            </Row>

            <hr />
            <Row className="pdTop10">

                <Col xs="3">
                    <FieldLabel label="Date of birth">  
                        <span>{ CommonUtils.getDisplayDate(certificate.dateOfBirth)}</span>
                    </FieldLabel>
                </Col>

                <Col xs="3">
                    <FieldLabel label="Course">
                        <span>{certificate.batch.course.courseName}</span>
                    </FieldLabel>
                </Col>

                <Col xs="3">
                    <FieldLabel label="Course Code">
                        <span>{certificate.batch.course.courseCode}</span>
                    </FieldLabel>
                </Col>

                <Col xs="3">
                    <FieldLabel label="Batch Number">
                        <span>{certificate.batch.batchNumber} </span>
                    </FieldLabel>
                </Col>
            </Row>

            { /* As discussed with Densingh, College Name & College address are removed 
            <hr />
            <Row className="pdTop10">

                <Col xs="3">
                    <FieldLabel label="College">
                        <span>{certificate.batch.college.collegeName}</span>
                    </FieldLabel>
                </Col>

             
                <Col xs="6">
                    <FieldLabel label="College Address">
                        <div>
                        <span>{certificate.batch.college.address1}</span> <br />
                        <span>{certificate.batch.college.address2}</span>
                        </div>
                    </FieldLabel>
                </Col>

              
            </Row>*/}
        
            <hr />

            <Row className="pdTop10">

                <Col xs="3">
                    <FieldLabel label="Batch Start Date">
                        <span>{CommonUtils.getDisplayDate(certificate.batch.batchStartDate)}</span>
                    </FieldLabel>
                </Col>

                <Col xs="3">
                    <FieldLabel label="Batch End Date">
                        <span>{CommonUtils.getDisplayDate(certificate.batch.batchEndDate)}</span>
                    </FieldLabel>
                </Col>

                <Col xs="3">
                    <FieldLabel label="Certificate Issue Date">
                        {/* As per discussion with Densigh show Certificate Issue date as Batch end date */ }
                        <span>{CommonUtils.getDisplayDate(certificate.batch.batchEndDate)}</span>
                    </FieldLabel>
                </Col>
            </Row>

  
            { /* 
            31/12/21 fix: Batch timings,Mobile No,Email, certificate needs to be removed
            <Row className="pdTop10">
                <Col xs="3">
                    <FieldLabel label="EMail">
                        <span>{certificate.email} </span>
                    </FieldLabel>
                </Col>

                <Col xs="3">
                    <FieldLabel label="Mobile Number">
                        <span>{certificate.mobileNumber}</span>
                    </FieldLabel>
                </Col>
            </Row>
           

            <hr />

            <Row className="pdTop10">

                <div>
                    <span className="subHeader"> Certificate </span>
                </div>

   
            </Row>
            <Row className="pdTop10">        
                <div className="certificate">
                    {(certificate.certificateContent == null) ? <h5 className="aligncenter">Certificate Not uploaded </h5> :
                        <img className="certificate" src={"data:image/png;base64 ," + certificate.certificateContent} />}
                </div>
             
            </Row>
             */ }
        </div>);
    }

     NO_CONTENT_STATUS_CODE = 204;

     async validateCertificate() {

         this.setState({
             status: Status.Processing,
             statusMessage: "Validating Certificate.."
         });

         var result = await this.studentCourseService.getCertificateDetails(this.formState.certificateNumber);

         if (result.status == this.NO_CONTENT_STATUS_CODE) {
             //No content. Certificate doesn't exist..
             this.setState({
                 status: Status.None,
                 certificate:  null,
                 isValidCertificate: false
             });
         }
         else {
            // Valid certificate details exists
             this.setState({
                 status: Status.None,
                 certificate: result.data,
                 isValidCertificate: true
             });
         }
     }

     renderCertificateNumber() {
         return (<Row className="pdTop10">
             <Col xs="3-5">

                 <TextBox
                     label="Certificate Number"
                     prefix={<span className="pd5 themeIcon fa fa-search"></span>}
                     text={this.formState.certificateNumber}
                     onChange={(e: { target: { value: string; }; }) => {
                         this.formState.certificateNumber = e.target.value;
                        // Just to refresh UI
                         this.setState({});
                     }}
                     fieldName="certificateNumber" />
             </Col>

             <Col xs="3" className="pdleft10 pdTop30">
                 <Button onClick={(e) => {
                     this.validateCertificate();
                 }}>Validate</Button>
             </Col>
         </Row>);
     } 


     renderTopBar(){
        return  (<Navbar expand="md">
         <Row className="align-items-center">
          <Col size={1} sm={2}>
            <img className="logoImg"  src={logo} alt="Logo" />
          
          </Col>

          <Col md={4}>
            <span className="brand-name cen">MAG Institute Of Maritime Academy</span>
          </Col>
         
          <Col md="6">
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon" /> 
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="/" className="navbar-link">Home</Nav.Link>

              <Nav.Link href="/home#skills" className="navbar-link">About Us</Nav.Link>

              <Nav.Link href="/home#project" className="navbar-link">Our Services</Nav.Link>
            </Nav>
            <span className="navbar-text">
              {/* <div className="social-icon">
                <a href="#"><img src={navIcon1} alt="" /></a>
                <a href="#"><img src={navIcon2} alt="" /></a>
                <a href="#"><img src={navIcon3} alt="" /></a>
              </div> */}
            
            </span>
          </Navbar.Collapse>
          </Col>
        </Row>
        </Navbar>);
     }

     render() {
         return (
            <>
           { this.renderTopBar() }
         <div className="content">
               <h1>Validate certificate</h1>

             <div className="pdTop10">
                 {(this.state.status == Status.Processing) &&
                     <LoadingSpinner message={this.state.statusMessage}></LoadingSpinner>
                 }
             </div>

                <hr />
                
             <div className="pdTop10 col-5">
             {this.renderCertificateNumber()}
             </div> 
             <hr />

             <div>
                 <div>
                    {   
                         (this.state.isValidCertificate != null) &&
                         ((this.state.isValidCertificate) ? this.renderCertificateDetails() :
                             <div> <h6 className="error"> No certificate found!.. </h6>
                               </div>)
                     }
                 </div>
             </div>
           
         </div></>);
     }
 }
 


// export const ValidateCertificate = () => {
//   return (
//     <div><h1>
//         ValidateCertificate</h1></div>
//   )
// }


